[
    {
        "question": "Can we issue the long Term policy for one month",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " No Long Term Policy start with a minimum period of 3 Years"
        ]
    },
    {
        "question": "Who can take a fire policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Legal owner of the property. If the property is owned by two or more persons in joint name, name of all the owners to appear under Insured. Financier can also take the insurance. Policy to be issued in the name of actual owner and interest of the financier to be protected under agreed bank clause. Loss would be payable to the named financier, the same can be paid to the Insured subject to NOC from the Financier. A tenant can also take the insurance covering only the contents belonging to him"
        ]
    },
    {
        "question": "Can Corporate take long Term Policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes Corporate can take long term policy but premium should be higher compare to Individual Dwellings"
        ]
    },
    {
        "question": "Does Contents are covered under Long Term Policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No. Only super structures and Improvements are covered."
        ]
    },
    {
        "question": "Does Boundary wall can be covered in this policy.",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes Boundary wall can be covered if sum insured is included in Total Sum Insured"
        ]
    },
    {
        "question": "What are the Add On Covers",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Omission to insure, Additional Expenses for alternate accommodation, Loss of rent, Removal Of debris,Architect , Surveyor and consulting engineer fees, Impact Damage."
        ]
    },
    {
        "question": "Do I need to give bifurcation of values for building, boundary walls, plinth, internalroads etc?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No need to give separate bifurcation for each such item. All permanent civil structure within boundary walls of your independent house are covered. But you should indicate broadly what all items / components included in building –such as plinth and foundation, compound wall, Electrical fittings, Fixed Glasses etc"
        ]
    },
    {
        "question": "Due to heavy wind (storm), glass panes of window of my house have broken. Is it an event insured in the SFSP insurance policy?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes, storm is an insured perils in SFSP."
        ]
    },
    {
        "question": ".In case insured property is sold to other owner, will this insurance policy be transferred in the  name of new owner?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "NO. Insurance policy has to be cancelled and refund, if any, to be allowed to the insured. New owner has to take a fresh insurance cover"
        ]
    },
    {
        "question": "In case of death of the owner of the property, it is inherited to the legal heir. Will this insurance policy remain operational in the name of new owner?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes, in such a case, by providing relevant documents in this regard, it may be transferred in thename of legal heir."
        ]
    },
    {
        "question": "Cost of construction of house is INR 50 Lakhs. I have spent additional INR 20 Lakhs on its furnishing and INR 4 Lakhs on Stamp Duty for registered agreement. How much do I take as sum insured in the policy for cover on reinstatement Value basis?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "INR 74 Lakhs"
        ]
    },
    {
        "question": "My house is badly damaged and now repair work is going on. It will take at least 6 months time. Now we have to shift to a rented accommodation @ INR 20,000/-per month rent. I have taken additional rent cover under SFSP policy with a limit up to Rs. 35000/-per month for 12 months. How much reimbursement will I get under this extension ?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "You will get the actual difference between the rent you ought to pay in the original accommodation and the rent you will pay innew accommodation, on production of relevant proofs"
        ]
    },
    {
        "question": "Is there any discount facilities if insured is opted for a long Term Tenure like 5 Years or 10 Years",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes Insured will get the discount maximum upto50% based on the tenure selected"
        ]
    },
    {
        "question": "What are the possible deductions from a claim in case of a loss in SFSP policy?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Deduction from a fire claim is on following accounts: Depreciation, Salvage, Under insurance / Average clause, Deductible"
        ]
    },
    {
        "question": "There is a fire in next building to my house, and my house is also damaged in that fire. Will mypolicy cover damages to my house due to fire.",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yes, as cause of loss is Fire"
        ]
    },
    {
        "question": "While doing renovation at home, if the home building collapses, will it be covered in this insurance policy?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No. Any incidence which is caused by the events as mentioned in the insurance policy is only covered"
        ]
    },
    {
        "question": "can we cancel the policy in mid term",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yesinsured can cancel the policy on mid term but premium should be as per condition mentioned in policy wordings"
        ]
    },
    {
        "question": "can we replace the property which is insured if sum insured is same",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No you cannot replace the property, On such scenario policy to be cancelled and reissue a fresh policy with current address"
        ]
    },
    {
        "question": "Once the policy is issued can insured have the option to correct the address",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " Yes insured can have the option to correct it by putting endorsement request however the correction should be only spelling mistake or modification but it should not be any change in district, pin code, state which is subject to additional premium"
        ]
    },
    {
        "question": "can we increase or decrease the sum insured in policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Yeswe can subject to additional premium to be charged however for decrease in sum insured there should not be any refund"
        ]
    },
    {
        "question": "if we went for vacation and if the premise is left unoccupied for more than continuous 30 days and is there any claim occurred on that period does it cover",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No it is not covered if property is unoccupied for more than continuous 30 days"
        ]
    },
    {
        "question": "Property Value is 30crs however we have taken the insurance for only 15crs and at the time of claim can I get 15Crs?",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No. Underinsurance will be applicable and claim will be paidon proportion basis of actual sum insuredFor example –if Sum insured is INR 15 Crs and value of the property is INR 30 Crs –means insured has taken insurance for 50%. And any loss payable will be reduced by 50% of the loss on account of under insurance"
        ]
    },
    {
        "question": "What are the benefits of add on covers",
        "is_answer_multiple": true,
        "is_answer_header": false,
        "answer": [
            "Removal of debris will cover the additional expenses upto10% for removing the debris",
            "Architect,Surveyor & Consulting Engineer Fees : will cover the additional expenses upto 7.5% which is occurred",
            "Impact Damage : if there is any impact to insured property by insured own vehicles then such losses is covered undersaid add on",
            "Omission to insure : additions, alterations or extensions (maximum upto 5% of fixed assets sum insured (not applicable for stock) –This is to provide automatic cover to the assets capitalized after inception of the insurance policy where Insured fails to intimate insurer within reasonable time to endorse in the policy",
            "Loss of rent –Following insured loss to the insured property/building which was given on rent, stops generating rent revenue to the Insured. The said loss can be recovered under this add on. Insured has to provide the limit per month and the total duration required at the time of taking the policy.",
            "Additional expenses of rent for alternative accommodation –Following an insured loss to theProperty/Building, the insured hasto vacate the said premise and shift to alternate accommodation. The difference of rent can be recovered under the policy under this add on . Insured to provide expenses limit per month and requisite duration to be declared at the time of taking policy"
        ]
    },
    {
        "question": "Does land cost is covered under property value",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Only reconstruction cost would be covered under property insurance"
        ]
    },
    {
        "question": "What kind of perils are covered",
        "is_answer_multiple": false,
        "is_answer_header": true,
        "answer_header": [
            "The following perils are covered. Perils covered are as under (12 Named Perils)"
        ],
        "answer": [
            " • Fire • Lightning • Explosion/Implosion • Impact Damage by rail/road vehicle not owned by Insured • Riot, Strike, Malicious Damage • Storm, Flood, Inundation, Tempest, Typhoon, Hurricane, Tornado, Cyclone including  Earthquake • Landslide, Rockslide, subsidence • Damage by Aircraft and any aerial article dropped therefrom • Missile Testing operation • Bursting and Overflowing from Water Tanks and Pipelines • Leakage from Sprinkler Installation • Bush Fire"
        ]
    },
    {
        "question": "Does forest fires are covered in this policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            " No only bush fire is covered. If insured require forest fire then additional premium to be paid for same"
        ]
    },
    {
        "question": "Does Theft is covered in this policy",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "No Theft is exclusion"
        ]
    },
    {
        "question": "if there is any hypothecation and at the time of claim who will get the claim amount insured or bank",
        "is_answer_multiple": false,
        "is_answer_header": false,
        "answer": [
            "Bank will get the claim amount due to hypothecation in the policy"
        ]
    }
]